// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore"
import { getAuth } from "firebase/auth"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCzFD2sxUXdObVvkmy8vgbza-06Mij264Y",
    authDomain: "rico-booking-app.firebaseapp.com",
    projectId: "rico-booking-app",
    storageBucket: "rico-booking-app.firebasestorage.app",
    messagingSenderId: "829918786450",
    appId: "1:829918786450:web:585defd94a593a1fa3874b",
    measurementId: "G-5EGN2PX6HK"
}

const getCollectionName = (collectionName) => {
    let is_production = window.location.href.includes("staging") || window.location.href.includes("localhost") ? false : true
    return collectionName ? (is_production ? "rico_" : "staging_rico_") + String(collectionName) : ""
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
// const analytics = getAnalytics(app); 
const db = getFirestore(app)
const auth = getAuth(app)

// Export db for use in other files
export { db, auth, getCollectionName }